const slugifyPart = (value = '') =>
  String(value)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();

export const buildCollaboratorSlug = (collaborator = {}) => {
  const mainProfession =
    collaborator.display_profession ||
    collaborator.organization_category ||
    collaborator.organization_type;
  const parts = [
    collaborator.organization_name || collaborator.name,
    mainProfession,
    collaborator.city,
  ]
    .map(slugifyPart)
    .filter(Boolean);

  return parts.join('-') || collaborator.id || '';
};

export const collaboratorProfilePath = (collaborator = {}) =>
  `/collaborator/${collaborator.seo_slug || collaborator.slug || buildCollaboratorSlug(collaborator) || collaborator.id}`;
